// extracted by mini-css-extract-plugin
export default {"container":"cardPage_container__aDD45","link":"cardPage_link__4xI1V","linkuno":"cardPage_linkuno__9430T","info":"cardPage_info__NTjv2","opacity":"cardPage_opacity__Mle+u"};